export enum MediaManagerSDKBoardSitesVisibility {
  All = 'all',
  Current = 'current',
}
